import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_MEDIUM,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import ValueHelper, {floorFraction, roundFraction} from "../../utils/ValueHelper";
import {Button} from "@material-ui/core";
import {ColorBackground, ColorSubTitle, ColorTheme, ColorTitle} from "src/styles/Colors";
import TextView from "../commons/TextView";
import Slider from "@material-ui/core/Slider";
import {isCurrentPlanEnded, isCurrentPlanPaid} from "../../utils/ActivityHelper";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import {withStyles} from "@material-ui/core/styles";
import Space from "src/js/components/commons/Space";
import {ImageIcon} from "src/js/components/commons/ViewHelper";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = () => ({
  viewPlaceholder: {
    flexDirection: 'column',
    marginBottom: 4,
    minWidth: 140,
  },
  fieldSlider: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    // paddingTop: 6,
    paddingBottom: 6,
  },
  slider: {
    display: 'flex',
    flex: 1,
    marginLeft: 6,
    marginRight: 6
  }
});

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const IOSSlider = withStyles({
  root: {
    color: ColorTheme,
    height: 2,
    padding: '15px 0',
  },
  thumb: {
    height: 16,
    width: 16,
    // backgroundImage: require('src/images/ic_checked.png'),
    // // backgroundColor: ColorTheme,
    // boxShadow: iOSBoxShadow,
    marginTop: -8,
    marginLeft: -8,
    // '&:focus, &:hover, &$active': {
    //   boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
    //   // Reset on touch devices, it doesn't add specificity
    //   '@media (hover: none)': {
    //     boxShadow: iOSBoxShadow,
    //   },
    // },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 0px)',
    // top: -28,
    // '& *': {
    //   background: ColorTheme,
    //   color: '#fff',
    // },
  },
  track: {
    height: 2,
  },
  rail: {
    height: 2,
    opacity: 0.5,
    backgroundColor: '#bfbfbf',
  },
  mark: {
    backgroundColor: '#bfbfbf',
    height: 8,
    width: 1,
    marginTop: -3,
  },
  markActive: {
    opacity: 1,
    backgroundColor: 'currentColor',
  },
})(Slider);

const VALUE_MAX = 999999999;

class ManageActivityCharge extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.plan = null;
    let planId = activityData.planId;
    const adInfo = activityData.adInfo;
    if (adInfo) {
      if (adInfo.plans) {
        adInfo.plans.forEach((planL) => {
          if (planL.id === planId) {
            this.plan = planL;
          }
        });
      }
    }

    const isPaidOngoing = isCurrentPlanPaid(activityData.ad) && !isCurrentPlanEnded(activityData.ad);

    this.state = {
      sections: [
        {id: 1, labelId: isPaidOngoing ? 'activity.manage.extendYourPremiumPlan' : 'activity.manage.buildYourPremiumPlan',
          subLabelId: isPaidOngoing ? 'activity.manage.sectionHintAdBudgetExtend' : 'activity.manage.sectionHintAdBudget',
          expandAlways: true},
      ],
      scaleDuration: 10,
      scaleViews: 0,
      scaleDailyViews: 0,
      dailyViewsData: null,
      usePoints: false,
      showValidationMsg: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    this.processPlan();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  processPlan() {
    const {activityData} = this.props;
    if (this.plan) {
      const planDuration = activityData.planDuration;
      const planViews = activityData.planViews;
      const planDailyViews = activityData.planDailyViews;

      this.pvdMatrix = this.plan.pVDMatrix;
      this.basePrice = this.pvdMatrix.bp;
      this.durationMultipliers = this.pvdMatrix.d;
      this.viewMultipliers = this.pvdMatrix.v;
      this.discountMultipliers = this.pvdMatrix.ds;
      this.questionFixed = this.pvdMatrix.qf;
      this.questionPercent = this.pvdMatrix.qp;
      this.showcaseFixed = this.pvdMatrix.sf;
      this.showcasePercent = this.pvdMatrix.sp;

      this.durationData = [];
      let scaleDuration = 0;
      if (this.durationMultipliers) {
        let index = 0;
        this.durationMultipliers.forEach((multiplier) => {
          const scaleValue = index++ * 10;
          this.durationData.push({value: scaleValue, label: ValueHelper.getDisplayValue(multiplier.k)});
          if (planDuration) {
            if (planDuration === multiplier.k) {
              scaleDuration = scaleValue;
            }
          } else if (multiplier.d === 1) {
            scaleDuration = scaleValue;
          }
        });
      }
      this.viewsData = [];
      let scaleViews = 0;
      if (this.viewMultipliers) {
        let index = 0;
        this.viewMultipliers.forEach((multiplier) => {
          const scaleValue = index++ * 8;
          this.viewsData.push({value: scaleValue, label: this.getDisplayValue(multiplier.k)});
          if (planViews) {
            if (planViews === multiplier.k) {
              scaleViews = scaleValue;
            }
          } else if (multiplier.d === 1) {
            scaleViews = scaleValue;
          }
        });
      }
      const dailyViewsData = this.calculateDailyViewsData(scaleDuration, scaleViews);
      // const scaleDailyViews = planDailyViews ? planDailyViews : dailyViewsData.min;
      const scaleDailyViews = planDailyViews ? planDailyViews : dailyViewsData.max;
      this.setState({scaleDuration, scaleViews, scaleDailyViews, dailyViewsData});
    }
  }

  getMarksIndex(data, value) {
    return data.findIndex((mark) => mark.value === value);
  }

  calculatePrice(scaleDuration, scaleViews) {
    const {wallet} = this.props;
    const durationIndex = this.getMarksIndex(this.durationData, scaleDuration);
    const duration = this.durationMultipliers[durationIndex].k;
    const durationMultiplier = this.durationMultipliers[durationIndex].m;
    const viewsIndex = this.getMarksIndex(this.viewsData, scaleViews);
    let viewsCount = this.viewMultipliers[viewsIndex].k;
    const viewMultiplier = this.viewMultipliers[viewsIndex].m;
    let discount = 0;
    if (this.discountMultipliers && this.discountMultipliers.length > 0) {
      this.discountMultipliers.forEach((discountMultiplier) => {
        if ((discountMultiplier.v === 0 || discountMultiplier.v === viewsCount) && (discountMultiplier.d === 0 || discountMultiplier.d === duration)) {
          discount = discountMultiplier.m;
        }
      });
    }

    let cost = this.basePrice + durationMultiplier + viewMultiplier;
    let bPrice = cost;

    let qPrice = 0;
    if (this.props.activityData.inQuestion) {
      qPrice = this.questionFixed + cost * this.questionPercent/100;
    }
    let scPrice = 0;
    if (this.props.activityData.showcase) {
      scPrice = this.showcaseFixed + cost * this.showcasePercent/100;
    }
    cost += qPrice;
    cost += scPrice;
    let price = cost;

    let dPrice = price;
    if (discount > 0) {
      cost = Math.max(0, cost - cost * discount/100);
      dPrice = cost;
    }

    if (this.plan.exchangeRate !== 1) {
      qPrice *= this.plan.exchangeRate;
      scPrice *= this.plan.exchangeRate;
      bPrice *= this.plan.exchangeRate;
      price *= this.plan.exchangeRate;
      dPrice *= this.plan.exchangeRate;
      cost *= this.plan.exchangeRate;
    }
    cost = roundFraction(cost, 2);

    let points = undefined;
    let pointsValue = undefined;
    let minPoints = undefined;
    if (wallet && wallet.sPoints > 0 && wallet.sPointsValue > 0) {
      const perPointValue = wallet.sPointsValue / wallet.sPoints;
      minPoints = Math.ceil(0.01 / perPointValue);
      if (this.state.usePoints) {
        let sPointsValue = wallet.sPointsValue;
        points = wallet.sPoints;
        if (sPointsValue > cost) {
          sPointsValue = cost;
          points = Math.ceil(sPointsValue / perPointValue);
        }
        pointsValue = sPointsValue;
        pointsValue = floorFraction(pointsValue, 2);
        cost = Math.max(0, cost - sPointsValue);
      }
    }
    return {
      qPrice: roundFraction(qPrice, 2),
      scPrice: roundFraction(scPrice, 2),
      bPrice: roundFraction(bPrice, 2),
      price: roundFraction(price, 2),
      dPrice: roundFraction(dPrice, 2), // discounted price
      ePrice: roundFraction(cost, 2),
      minPoints: minPoints,
      points: points,
      pointsValue: pointsValue,
    };
  }

  calculateDailyViewsData(scaleDuration, scaleViews) {
    const durationIndex = this.getMarksIndex(this.durationData, scaleDuration);
    const duration = this.durationMultipliers[durationIndex].k;
    const viewsIndex = this.getMarksIndex(this.viewsData, scaleViews);
    const viewsCount = this.viewMultipliers[viewsIndex].k;
    const minViewsPerDay = Math.ceil(viewsCount/duration);
    const maxViewsPerDay = viewsCount;
    return {
      min: minViewsPerDay,
      max: maxViewsPerDay,
      step: 100,
      data: [
        {value: minViewsPerDay, label: this.getDisplayValue(Math.ceil(minViewsPerDay))},
        {value: maxViewsPerDay, label: this.getDisplayValue(Math.ceil(maxViewsPerDay))},
      ],
      disabled: duration === 1,
    };
  }

  updatePlanDailyViewsData() {
    const {dailyViewsData, scaleDailyViews} = this.state;
    if (dailyViewsData && dailyViewsData.data) {
      if (scaleDailyViews !== dailyViewsData.data[0].value
        && scaleDailyViews !== dailyViewsData.data[dailyViewsData.data.length -1].value) {
        const newMarker = {value: scaleDailyViews, label: this.getDisplayValue(scaleDailyViews)};
        if (dailyViewsData.data.length === 2) {
          dailyViewsData.data.splice(1, 0, newMarker);
        } else if (dailyViewsData.data.length === 3) {
          dailyViewsData.data[1] = newMarker;
        }
      }
    }
    return dailyViewsData;
  }

  getPlanDuration(scaleDuration) {
    let durationIndex = this.getMarksIndex(this.durationData, scaleDuration);
    if (durationIndex < 0) {
      durationIndex = 0;
    }
    return this.durationMultipliers[durationIndex].k;
  }

  getPlanViews(scaleViews) {
    let viewsIndex = this.getMarksIndex(this.viewsData, scaleViews);
    if (viewsIndex < 0) {
      viewsIndex = 0;
    }
    return this.viewMultipliers[viewsIndex].k;
  }

  getDisplayValue(value) {
    if (value === VALUE_MAX) {
      return '∞';
    }
    return ValueHelper.getDisplayValue(value);
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  getData(excludeError) {
    const {
      scaleDuration,
      scaleViews,
      scaleDailyViews,
    } = this.state;

    if (!excludeError) {
      // if (adState === constants.activity.state.ACTIVE && (!adBudget || !adDailyBudget)) {
      //   this.updateState({showValidationMsg: true});
      //   return false;
      // }
    }
    const planValue = this.calculatePrice(scaleDuration, scaleViews);
    const planPrice = planValue.ePrice;
    return {
      planDuration: this.getPlanDuration(scaleDuration),
      planViews: this.getPlanViews(scaleViews),
      planDailyViews: scaleDailyViews,
      planPrice: planPrice,
      planPayCurrency: this.plan ? this.plan.currency : '',
      planPayCurrencyCode: this.plan ? this.plan.currencyCode : '',
      planPay: planPrice,
      planPayPoints: planValue.points,
      planPayPointsValue: planValue.pointsValue,
      planPaySuccess: false,
    };
  }

  render() {
    if (!this.pvdMatrix) {
      return null;
    }

    const {activityData, classes, isXS, wallet} = this.props;
    const {
      sections,
      showValidationMsg,
      scaleDuration,
      scaleViews,
      scaleDailyViews,
      dailyViewsData,
      usePoints
    } = this.state;

    const planValue = this.calculatePrice(scaleDuration, scaleViews);
    const basePrice = planValue.bPrice;
    const finalPrice = planValue.ePrice;
    const price = planValue.price;
    const priceQuestion = planValue.qPrice;
    const priceShowcase = planValue.scPrice;
    const discountedPrice = planValue.dPrice;
    const minPoints = planValue.minPoints;
    const points = planValue.points;
    const pointsValue = planValue.pointsValue;
    const rawPointsValue = wallet.sPointsValue;

    let disableCheckUsePoints = false;
    if (discountedPrice > 0 && wallet && wallet.sPoints > 0 && wallet.sPoints >= minPoints) {
      disableCheckUsePoints = false;
    }

    const inputSpace = isXS ? FIELD_SPACE_XS : FIELD_SPACE;
    return (
      <div className={classes.flexColumnNoCenter}>
        {/*<SectionHeaderView labelId={sections[0].subLabelId} />*/}
        {/*<FieldSpace />*/}

        <div className={classes.fieldSlider}>
          <div className={classes.viewPlaceholder} >
            <SectionHeaderView labelId={'activity.planViewQ'} noBottomSpace={true}/>
          </div>
          <div className={classes.viewRow}>
            <IOSSlider
              key={'scaleViews'}
              className={classes.slider}
              color={'secondary'}
              onChange={this.onChange.bind(this, 'scaleViews')}
              value={scaleViews}
              defaultValue={scaleViews}
              valueLabelFormat={this.getLabel.bind(this, this.viewsData)}
              step={0}
              valueLabelDisplay="auto"
              marks={this.viewsData}
              min={this.viewsData[0].value}
              max={this.viewsData[this.viewsData.length - 1].value}
            />
          </div>
        </div>
        <FieldSpace multiplier={4}/>

        <div className={classes.fieldSlider}>
          <div className={classes.viewPlaceholder} >
            <SectionHeaderView labelId={'activity.planDurationQ'} noBottomSpace={true}/>
          </div>
          <div className={classes.viewRow}>
            <IOSSlider
              key={'scaleDuration'}
              className={classes.slider}
              color={'primary'}
              onChange={this.onChange.bind(this, 'scaleDuration')}
              value={scaleDuration}
              defaultValue={scaleDuration}
              valueLabelFormat={this.getLabel.bind(this, this.durationData)}
              step={0}
              valueLabelDisplay="auto"
              marks={this.durationData}
              min={this.durationData[0].value}
              max={this.durationData[this.durationData.length - 1].value}
            />
          </div>
        </div>
        <FieldSpace />

        {/*<div className={classes.fieldSlider}>*/}
        {/*  <div className={classes.viewPlaceholder} >*/}
        {/*    <SectionHeaderView labelId={'activity.manage.dailyViewsCount'} noBottomSpace={true}/>*/}
        {/*  </div>*/}
        {/*  <div className={classes.viewRow}>*/}
        {/*    <IOSSlider*/}
        {/*      disabled={dailyViewsData.disabled}*/}
        {/*      key={'scaleDailyViews'}*/}
        {/*      className={classes.slider}*/}
        {/*      color={'secondary'}*/}
        {/*      onChange={this.onChange.bind(this, 'scaleDailyViews')}*/}
        {/*      value={dailyViewsData.disabled ? dailyViewsData.max : scaleDailyViews}*/}
        {/*      defaultValue={scaleDailyViews}*/}
        {/*      valueLabelFormat={this.getLabelForDaily}*/}
        {/*      step={dailyViewsData.step}*/}
        {/*      marks={dailyViewsData.data}*/}
        {/*      valueLabelDisplay="auto"*/}
        {/*      min={dailyViewsData.min}*/}
        {/*      max={dailyViewsData.max}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <FieldSpace multiplier={4}/>

        <div className={classes.viewColumnFullWidth}>
          <div className={classes.viewColumnFullWidth} style={{maxWidth: isXS ? 600 : 400}}>
            {discountedPrice > 0 && wallet && wallet.sPoints > 0 && wallet.sPointsValue > 0 ?
              <div className={classes.viewColumnFullWidthNoCenter1} style={{marginBottom: 20, paddingBottom: 12, borderWidth: 0, borderBottomWidth: 1, borderColor: ColorBackground, borderStyle: 'solid'}}>
                <div className={classes.viewRowFullWidth}>
                  <Checkbox
                    disabled={disableCheckUsePoints}
                    color={'primary'}
                    checked={usePoints}
                    onChange={this.handleCheckUsePoints}
                    style={{marginLeft: -12, marginRight: -12, opacity: disableCheckUsePoints ? 0.4 : 1}}
                  />
                  <Space vertical={12}/>
                  <TextView
                    variant={'body1'}
                    color={ColorTitle}
                    text={<FormattedMessage id={'activity.use'}/>}
                  />
                  <Space vertical={12}/>
                  <ImageIcon src={require('src/images/ic_coin.png')} width={18} height={18}/>
                  <Space vertical={8}/>
                  <TextView
                    variant={'body1'}
                    color={ColorTitle}
                    text={points || wallet.sPoints}
                  />
                  <div className={classes.flex1}/>
                  <div className={classes.viewRow}>
                    <TextView
                      variant={'body1'}
                      color={ColorTitle}
                      text={<FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: pointsValue || rawPointsValue}} />}
                    />
                  </div>
                </div>
                {disableCheckUsePoints ?
                  <TextView
                    variant={'caption'}
                    color={ColorSubTitle}
                    text={<FormattedMessage id={'activity.insufficientBalanceToConsume'} values={{value: minPoints}} />}
                  />
                  : null
                }
              </div>
              : null
            }
            {priceQuestion > 0 || priceShowcase > 0 ?
              <div className={classes.viewColumnFullWidth} style={{marginBottom: 20}}>
                <div className={classes.viewRowFullWidth}>
                  <TextView
                    variant={'body1'}
                    color={ColorTitle}
                    text={<FormattedMessage id={'activity.price'}/>}
                  />
                  <div className={classes.flex1}/>
                  <div className={classes.viewRow}>
                    <TextView
                      variant={'body1'}
                      color={ColorTitle}
                      text={<FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: basePrice}} />}
                    />
                  </div>
                </div>
                {priceQuestion > 0 ?
                  <div className={classes.viewRowFullWidth} style={{marginTop: 16}}>
                    <TextView
                      variant={'body1'}
                      color={ColorTitle}
                      text={<FormattedMessage id={'activity.qPrice'}/>}
                    />
                    <div className={classes.flex1}/>
                    <div className={classes.viewRow}>
                      <TextView
                        variant={'body1'}
                        color={ColorTitle}
                        text={<FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: priceQuestion}} />}
                      />
                    </div>
                  </div>
                  : null
                }
                {priceShowcase > 0 ?
                  <div className={classes.viewRowFullWidth} style={{marginTop: 16}}>
                    <TextView
                      variant={'body1'}
                      color={ColorTitle}
                      text={<FormattedMessage id={'activity.scPrice'}/>}
                    />
                    <div className={classes.flex1}/>
                    <div className={classes.viewRow}>
                      <TextView
                        variant={'body1'}
                        color={ColorTitle}
                        text={<FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: priceShowcase}} />}
                      />
                    </div>
                  </div>
                  : null
                }
              </div>
              : null
            }
            <div className={classes.viewRowFullWidth} style={{marginBottom: 12}}>
              <TextView
                variant={'h6'}
                color={ColorTitle}
                text={<FormattedMessage id={'activity.manage.totalCost'}/>}
                fontWeight={FONT_WEIGHT_BOLD} />
              <div className={classes.flex1}/>
              <div className={classes.viewRow}>
                {finalPrice !== price && price > 0 ?
                  <React.Fragment>
                    <TextView
                      variant={'h6'}
                      color={ColorSubTitle}
                      style={{textDecoration: 'line-through'}}
                      text={<FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: price}} />}/>
                    <Space verticalSpace={2}/>
                  </React.Fragment>
                  : null
                }
                <TextView
                  variant={'h6'}
                  color={ColorTitle}
                  text={finalPrice > 0 ? <FormattedMessage id={'activity.moneyWithCurrency'} values={{value1: this.plan ? this.plan.currency : '', value2: finalPrice}} /> : <FormattedMessage id={'activity.chargeFree'}/>}
                  fontWeight={FONT_WEIGHT_BOLD} />
              </div>
              {/*<TextView*/}
              {/*  variant={'body2'}*/}
              {/*  color={ColorSubTitle}*/}
              {/*  text={<FormattedMessage id={'activity.manage.totalCostPerViewWithValue'} values={{value1: this.plan ? this.plan.currency : '', value2: ValueHelper.getDisplayValue(price/this.getPlanViews(scaleViews)*1000, 4)}} />}*/}
              {/*/>*/}
            </div>
            <div className={classes.viewRowFullWidth} style={{justifyContent: 'flex-end'}}>
              <TextView
                variant={'body2'}
                color={ColorSubTitle}
                text={<FormattedMessage id={'payment.inclusiveOfVAT'} />}
                fontWeight={FONT_WEIGHT_MEDIUM} />
            </div>

            {!isXS ?
              <React.Fragment>
                <FieldSpace multiplier={1}/>
                <Button
                  size={'large'}
                  disableElevation
                  fullWidth
                  variant={'contained'}
                  color={"primary"}
                  onClick={this.onPayClicked}>
                  {<FormattedMessage id={finalPrice > 0 ? 'activity.payNPublish' : 'activity.publishNow'} />}
                </Button>
              </React.Fragment>
              : null
            }
          </div>
        </div>
        <FieldSpace />
      </div>
    )
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  getLabel = (data, value) => {
    const index = this.getMarksIndex(data, value);
    if (index >= 0) {
      return data[index].label;
    }
    return '';
  };

  getLabelForDaily = (value) => {
    return this.getDisplayValue(value);
  };

  handleCheckUsePoints = (event) => {
    this.updateState({usePoints: event.target.checked});
  }

  onChange = (name, event, value) => {
    let {scaleDuration, scaleViews, scaleDailyViews, dailyViewsData} = this.state;
    if (name === 'scaleDuration' || name === 'scaleViews') {
      if (name === 'scaleDuration') {
        scaleDuration = value;
      } else {
        scaleViews = value;
      }
      dailyViewsData = this.calculateDailyViewsData(scaleDuration, scaleViews);
      // scaleDailyViews = dailyViewsData.min;
      scaleDailyViews = dailyViewsData.max;
    } else if (name === 'scaleDailyViews') {
      scaleDailyViews = value;

      // this.clearTimer();
      // this.timerHandler = setTimeout(() => {
      //   this.setState({dailyViewsData: this.updatePlanDailyViewsData});
      // }, 500);
    }
    this.updateState({dailyViewsData: dailyViewsData, scaleDuration: scaleDuration, scaleViews: scaleViews, scaleDailyViews: scaleDailyViews});
  };

  onPayClicked = () => {
    if (this.props.moveNext) {
      this.props.moveNext();
    }
  };

  clearTimer() {
    if (this.timerHandler) {
      clearTimeout(this.timerHandler);
      this.timerHandler = null;
    }
  }

}

ManageActivityCharge.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  categories: PropTypes.array,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityCharge.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityCharge))
);
